import { container } from "tsyringe";
import ApiService from "../../services/ApiService";
import { ListPickupV2ApiRepository } from "../../repositories/api/ListPickupV2ApiRepository";
import { ListPickupV2Presenter } from "@/app/ui/presenters/ListPickupV2Presenter";
import { ListPickupV2Mapper } from "@/data/persistences/mappers/ListPickupV2Mapper";
import { ListPickupV2Endpoint } from "../../endpoints/ListPickupV2Endpoint";
import { ShipmentBookingMapper } from "@/data/persistences/mappers/ShipmentBookingMapper";

export class ListPickupV2Components {
  public static init() {
    container.register<ListPickupV2ApiRepository>(ListPickupV2ApiRepository, {
      useFactory: (d) =>
        new ListPickupV2ApiRepository(
          d.resolve(ApiService),
          d.resolve(ListPickupV2Mapper),
          d.resolve(ShipmentBookingMapper),
          d.resolve(ListPickupV2Endpoint)
        )
    });

    container.register<ListPickupV2Mapper>(ListPickupV2Mapper, {
      useClass: ListPickupV2Mapper
    });

    container.register<ListPickupV2Presenter>(ListPickupV2Presenter, {
      useFactory: (d) => {
        return new ListPickupV2Presenter(d.resolve(ListPickupV2ApiRepository));
      }
    });
  }
}
